import { ArrowForward, ArrowBack, Done } from "@material-ui/icons";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import config from "../../config/apiConfig";
import { getInfo } from "../../utils/hooks";
import "./Genre.scss";
import ReactGA from "react-ga";

const genres: { name: string; url: string }[] = [
    {
        name: "Horror",
        url: "https://i.pinimg.com/474x/a7/39/15/a739150622d0410f50ecd2479d84db84.jpg",
    },
    { name: "Romance", url: "https://assets.rbl.ms/14042538/980x.jpg" },
    {
        name: "Crime",
        url: "http://1.bp.blogspot.com/-Pa7LN2A8FJQ/UHbBETDftDI/AAAAAAAAAUY/ObmcAF0ct60/s1600/fsg-crime-scene-response-unit-01.jpg",
    },
    {
        name: "Thriller",
        url: "http://2.bp.blogspot.com/-TcX1y49_C5I/UFxrY4NA7hI/AAAAAAAAAOU/IoZH5El66to/s1600/tumblr_m94dgfigwC1rohp2no1_500.gif",
    },
    {
        name: "Comedy",
        url: "https://blog-images-ft.s3.amazonaws.com/custom/1546514742article_img.jpg",
    },
    {
        name: "Adventure",
        url: "https://nofilmschool.com/sites/default/files/styles/facebook/public/screen_shot_2019-06-18_at_1.30.02_pm.png?itok=lDnBE5q0",
    },
    {
        name: "Action",
        url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkmMv8cZ5JD3ITodqDRuMHLHL0w9k9O8HMLA&usqp=CAU",
    },
    {
        name: "Drama",
        url: "https://nofilmschool.com/sites/default/files/styles/article_wide/public/magnolia-final.jpg?itok=GHJ7m-XN",
    },
];

const Genre: React.FC = () => {
    const [selected, setSelected] = useState<string[]>([]);

    function isSelected(value: string): boolean {
        return selected.includes(value);
    }

    function submit() {
        const info = getInfo();
        if (!info) return;

        if (selected.length === 3) {
            info.genre = selected.join(",");

            const formData = new FormData();
            formData.append("token", config.token);
            formData.append("session-token", Cookies.get("token") ?? "");
            formData.append("device", "web");
            formData.append("genre", info.genre);
            formData.append("intent", info.intent);
            const requestOptions = {
                method: "POST",
                body: formData,
            };
            fetch(
                config.BASE_URL + "/idam/user/save_preference",
                requestOptions
            ).then(() => {
                ReactGA.event({
                    category: "AUTH",
                    action: "Save Preferences",
                    label: `intent: ${info.intent}\ngenre: ${info.genre}`,
                });
                Cookies.set("info", JSON.stringify(info));
                let elem = document.getElementById("genre-modal");
                if (elem) elem.style.display = "none";
            });
        }
    }

    useEffect(() => {
        if (!getInfo()?.genre) {
            let elem = document.getElementById("genre-modal");
            if (elem) elem.style.display = "grid";
        }
    }, []);

    return (
        <div
            className="modal modal-container"
            id="genre-modal"
            style={{ display: "none" }}
        >
            <div className="modal-wrapper">
                <div className="icon_button">
                    <ArrowBack />
                </div>
                <h4>One more step before we get started</h4>
                <p>Pick 3 genres you're interested to see stories from</p>
                <div className="genres">
                    {genres.map((genre) => (
                        <div
                            className={`genre ${
                                isSelected(genre.name) ? "selected" : ""
                            }`}
                            onClick={() => {
                                if (isSelected(genre.name)) {
                                    let newSelected = [
                                        ...selected.filter(
                                            (item) => item !== genre.name
                                        ),
                                    ];
                                    setSelected(newSelected);
                                } else {
                                    if (selected.length < 3) {
                                        setSelected([...selected, genre.name]);
                                    }
                                }
                            }}
                        >
                            {isSelected(genre.name) && <Done />}
                            <img src={genre.url} alt="" />
                            <small>{genre.name}</small>
                        </div>
                    ))}
                </div>
                <div className="modal-actions">
                    <p>
                        <span>{selected.length}/3</span>
                        genres selected
                    </p>
                    <button
                        className="icon_button"
                        onClick={submit}
                        disabled={selected.length < 3}
                    >
                        <ArrowForward style={{ pointerEvents: "none" }} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Genre;
